const stuckHeader = document.querySelector('.imkt-sticky') as HTMLElement;

export default class StickyHeader {
  static height() {
    return stuckHeader ? stuckHeader.offsetHeight : 0;
  }
}
